export default {
  required: " es requerido",
  email: "Email invalido",
  min: "El valor ingresado debe ser mayor a "
};
